export default class DtoUserCmsStatisticItem {
    constructor(obj) {
        this.category = obj.category
        this.title = obj.title
        this.visitsCount = obj.visitsCount
        this.lastAccess = obj.lastAccess
        this.headers = ['category', 'title', 'visitsCount', 'lastAccess']
    }
}